import React, { useState, useEffect, useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';

import classnames from 'classnames';
import {
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  FormGroup,
  Grid,
  TextField,
  Checkbox,
  Typography,
  RadioGroup,
  Radio,
} from '@material-ui/core';
import * as Yup from 'yup';
import Close from '@material-ui/icons/Close';
import { AppContext } from '../../../../AppContext';
import { ErrorMessage, FastField, FieldArray, Form, Formik, useField } from 'formik';

// SERVICES
import { putQaUser, getQaUserById, saveQAProfile } from '../../../../services';
import Loading from '../../../Loading/Loading';
import { QaDetailContext } from '../QaDetailContext';

const styles = theme => ({
  root: {
    height: '100%',
  },

  Tabs: {
    '& .MuiTab-root': {
      padding: 20,
    },
  },

  formHeaderServiceContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',

    '& span': {
      flex: 1,
      textAlign: 'left',
    },
  },

  formTextFieldInput: {
    padding: 15,
  },
  formTextFieldNotchedOutline: {
    '& fieldset': {
      borderColor: 'var(--jmi-blue) !important',
    },
  },
  errorMessage: {
    color: theme.palette.secondary.main,
    textAlign: 'center',
  },
});

const FormTextField = withStyles(styles)(({ formik, classes, inputProps, InputProps, label, ...props }) => {
  const { name, onChange } = props;
  const [field] = useField(props);

  return (
    <TextField
      name={name}
      label={label}
      autoComplete={name}
      margin="none"
      variant="outlined"
      fullWidth
      inputProps={{
        ...inputProps,
        className: classes.formTextFieldInput,
      }}
      InputProps={{
        ...InputProps,
        classes: {
          ...InputProps?.classes,
          focused: classes.formTextFieldNotchedOutline,
        },
      }}
      {...props}
      {...field}
      onChange={onChange || field.onChange}
    />
  );
});

const FormCheckbox = ({ formik, label, ...props }) => {
  const { name } = props;
  const [field] = useField(name);

  return (
    <FormControlLabel
      control={
        <Checkbox
          name={name}
          checked={field.value === true}
          onChange={e => formik.setFieldValue(name, e.target.checked)}
        />
      }
      label={label}
    />
  );
};

const FormControlWrapper = ({ children, ...props }) => (
  <Grid item xs={12} sm={6} md={4} {...props}>
    {/* <FormControl fullWidth> */}
    {/*  */}
    {children}
    {/* </FormControl> */}
  </Grid>
);

const formInitialValues = {
  name: '',
  password: '',
  mobilePhone: '',
  homePhone: '',
  workPhone: '',
  email: '',
  username: '',
  recordType: 'Active',
  wingspanID: '',
  fax: '',
  sketch: false,
  superUser: false,
  maxReports: '',
  fieldSupervisor: false,
  canProcessCancel: null,
  code: '',
  address: '',
  city: '',
  state: '',
  zip: '',
};

const formValidationSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  password: Yup.string().notRequired(),
  workPhone: Yup.string().notRequired(),
  mobilePhone: Yup.string().required('Required'),
  homePhone: Yup.string().notRequired(),
  email: Yup.string()
    .email()
    .required('Required'),
  username: Yup.string().required('Required'),
  recordType: Yup.string().required('Required'),
  sketch: Yup.bool(),
  superUser: Yup.bool(),
  maxReports: Yup.number().min(0, 'Must be greater than or equal to 0'),
  fieldSupervisor: Yup.bool(),
  canProcessCancel: Yup.bool().nullable(),
  code: Yup.string().required('Required'),
  address: Yup.string().required('Required'),
  city: Yup.string().required('Required'),
  state: Yup.string().required('Required'),
  zip: Yup.string()
    .length(5, 'Must be a valid 5 digit zip code')
    .required('Required'),
});

const getInitialFormValues = (initValues, existingValues = {}) => {
  const merged = Object.keys(initValues).reduce((acc, key) => {
    const initialValue = initValues[key];
    const existingValue = existingValues?.[key];

    acc[key] =
      Array.isArray(existingValue) || Array.isArray(initialValue) // if it's an array, take the array value
        ? existingValue || initialValue
        : initValues[key] !== null && typeof initValues[key] === 'object' // else - check if it is a spreadable object
        ? getInitialFormValues(initValues[key], existingValues?.[key])
        : // ? {
        //     ...initValues[key],
        //     ...existingValues?.[key],
        //   }
        // : existingValue === undefined // else check if the existing data is undefined and it needs to fallback to the init data values for the form to work
        [null, undefined].includes(existingValue) // else check if the existing data is undefined and it needs to fallback to the init data values for the form to work
        ? initialValue
        : existingValue;

    return acc;
  }, existingValues || {});

  return merged;
};

export const QaDetailProfileTab = withStyles(styles)(({ classes, match, history, ...props }) => {
  // PARAMS
  const { userId: mode } = match.params;
  // console.log("props",props);

  // STATE
  const [QAprofile, setQAProfile] = useState();

  // HOOKS
  const {
    state: { profile },
    dispatch: dispatchQa,
  } = useContext(QaDetailContext);
  const { dispatch } = useContext(AppContext);
  // COMPUTED
  const inCreateMode = mode === 'create';

  const getQaUserByIdAsync = async qaId => {
    try {
      const qaUserObj = await getQaUserById(qaId);
      setQAProfile(qaUserObj);
    } catch (error) {
      console.log(error);
    }
  };

  const showSnackbar = (message, variant) => {
    dispatch({
      type: 'SET_SNACKBAR',
      snackbar: { isOpen: true, message: message, variant: variant },
    });
  };

  const handleFormSubmission = async formValues => {
    try {
      
      const success = await saveQAProfile(formValues);
      const message = inCreateMode ? 'Profile created!' : 'Profile updated!';
      dispatchQa({
        type: 'UPDATE_PROFILE',
        profile: formValues,
      });
      showSnackbar(message, 'success');

      if (inCreateMode) {
        history.goBack();
      }
    } catch (error) {
      console.log(error);
      showSnackbar(error?.error || 'An error occurred. Please try again.', 'error');
    }
  };

  useEffect(() => {
         

    if (!inCreateMode) {
      if (!profile) {
        getQaUserByIdAsync(mode);
      } else {
        if (profile.qaId != props.qaUserId) {
          getQaUserByIdAsync(mode);
        } else {
          setQAProfile(profile);
        }
      }
    } else {
      setQAProfile(formInitialValues);
    }
  }, []);

  if (QAprofile) {
    QAprofile.wingspanId = 'QA' + QAprofile?.qaId;
  }

  return (
    <>
      <div>
        {/* loading state */}
        {!QAprofile && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              zIndex: 1,
            }}
          >
            <Loading size={100} style={{ position: 'absolute', top: 200, color: 'white' }} />
          </div>
        )}

        <Formik
          initialValues={getInitialFormValues(formInitialValues, QAprofile)}
          onSubmit={handleFormSubmission}
          validationSchema={formValidationSchema}
          enableReinitialize
          validateOnMount={true}
        >
          {formik =>{
            return (
              <Form>
                <Grid container spacing={2}>
                  <FormControlWrapper>
                    <FormTextField name="name" label="Name" formik={formik} required />
                    <span className={classes.errorMessage}>
                      <ErrorMessage name="name" />
                    </span>
                  </FormControlWrapper>
                  <FormControlWrapper>
                    <FormTextField name="mobilePhone" label="Mobile Phone" formik={formik} required />
                    <span className={classes.errorMessage}>
                      <ErrorMessage name="mobilePhone" />
                    </span>
                  </FormControlWrapper>
                  <FormControlWrapper>
                    <FormTextField name="homePhone" label="Home Phone" formik={formik} />
                    <span className={classes.errorMessage}>
                      <ErrorMessage name="homePhone" />
                    </span>
                  </FormControlWrapper>
                  <FormControlWrapper>
                    <FormTextField name="workPhone" label="Work Phone" formik={formik} />
                    <span className={classes.errorMessage}>
                      <ErrorMessage name="workPhone" />
                    </span>
                  </FormControlWrapper>
                  <FormControlWrapper>
                    <FormTextField name="email" label="Email" formik={formik} required />
                    <span className={classes.errorMessage}>
                      <ErrorMessage name="email" />
                    </span>
                  </FormControlWrapper>

                  {!inCreateMode && (
                    <FormControlWrapper>
                      <FormTextField name="wingspanId" label="Wingspan ID" defaultValue=" " formik={''} disabled />
                    </FormControlWrapper>
                  )}
                  {inCreateMode && <FormControlWrapper></FormControlWrapper>}
                  <FormControlWrapper>
                    <FormTextField name="username" label="Username" formik={formik} required />
                    <span className={classes.errorMessage}>
                      <ErrorMessage name="username" />
                    </span>
                  </FormControlWrapper>
                  <FormControlWrapper>
                    <FormTextField
                      name="password"
                      // type="password"
                      label={inCreateMode ? 'Password' : 'Password Update'}
                      // placeholder={inCreateMode ? '' : 'Only enabled when creating'}
                      formik={formik}
                      required={inCreateMode ? true : false}
                      // disabled={!inCreateMode}
                    />
                    <span className={classes.errorMessage}>
                      <ErrorMessage name="password" />
                    </span>
                  </FormControlWrapper>
                  <FormControlWrapper style={{ display: 'flex', alignItems: 'center' }}>
                    <FormCheckbox name="canProcessCancel" label="Process Cancellations" formik={formik} />
                  </FormControlWrapper>

                  <FormControlWrapper>
                    <FormTextField name="maxReports" label="Max Reports" formik={formik} />
                    <span className={classes.errorMessage}>
                      <ErrorMessage name="maxReports" />
                    </span>
                  </FormControlWrapper>
                  <FormControlWrapper>
                    <FormTextField name="code" label="Code" formik={formik} required />
                    <span className={classes.errorMessage}>
                      <ErrorMessage name="code" />
                    </span>
                  </FormControlWrapper>
                  <FormControlWrapper></FormControlWrapper>

                  <FormControlWrapper>
                    <FormTextField name="notes" label="Notes" multiline maxRows={4} formik={formik} defaultValue=" " />
                  </FormControlWrapper>
                </Grid>

                <Divider style={{ margin: '25px 0' }} />

                <Grid container spacing={2}>
                  {/* HOME ADDRESS */}
                  <Grid item xs={12} container justifyContent="flex-start">
                    <span>Home</span>
                  </Grid>
                  <FormControlWrapper>
                    <FormTextField name="address" label="Address" formik={formik} required />
                    <span className={classes.errorMessage}>
                      <ErrorMessage name="address" />
                    </span>
                  </FormControlWrapper>
                  <FormControlWrapper>
                    <FormTextField name="city" label="City" formik={formik} required />
                    <span className={classes.errorMessage}>
                      <ErrorMessage name="city" />
                    </span>
                  </FormControlWrapper>
                  <FormControlWrapper>
                    <FormTextField name="state" label="State" formik={formik} required />
                    <span className={classes.errorMessage}>
                      <ErrorMessage name="state" />
                    </span>
                  </FormControlWrapper>
                  <FormControlWrapper>
                    <FormTextField name="zip" label="Zip" formik={formik} required />
                    <span className={classes.errorMessage}>
                      <ErrorMessage name="zip" />
                    </span>
                  </FormControlWrapper>
                </Grid>

                <Divider style={{ margin: '25px 0' }} />

                <Grid container spacing={2}>
                  {/* Information */}

                  {!inCreateMode && (
                    <FormControlWrapper>
                      <Typography variant="subtitle1" style={{ marginRight: 10, textAlign: 'left' }}>
                        Record Type *
                      </Typography>
                      <RadioGroup
                        name="recordType"
                        value={formik.values.recordType}
                        onChange={formik.handleChange}
                        style={{ flexDirection: 'row', alignItems: 'center' }}
                      >
                        <FormControlLabel value="Active" control={<Radio />} label="Active" />
                        <FormControlLabel value="Inactive" control={<Radio />} label="Inactive" />
                      </RadioGroup>
                      <span className={classes.errorMessage}>
                        <ErrorMessage name="recordType" />
                      </span>
                    </FormControlWrapper>
                  )}
                </Grid>
                <div style={{ width: '100%', textAlign: 'center', marginTop: 15 }}>
                  {formik.isSubmitting ? (
                    <CircularProgress size={24} />
                  ) : (
                    <Button
                      type="submit"
                      size="medium"
                      color="primary"
                      variant="outlined"
                      onClick={formik.submitForm}
                      // color={formik.isValid ? 'action' : 'default'}
                      disabled={!formik.isValid || formik.isSubmitting}
                    >
                      Save
                    </Button>
                  )}
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </>
  );
});
